import { motion } from "framer-motion";
import { useState } from "react";
import { useGlobalContext } from "../GlobalContext/GlobalContext";

export const AnimatedLayout = ({ children }: React.PropsWithChildren) => {
  const context = useGlobalContext();
  const [duration, setDuration] = useState(context.firstPageLoading ? 1 : 0.2);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: duration }}
      onAnimationStart={() => {
        if (context.firstPageLoading) {
          context.firstPageLoaded();
          setDuration(0.2);
        }
      }}
      exit={{ opacity: 0 }}
      style={{ display: "flex", flexDirection: "column", flex: "1 1 auto", minHeight: 0 }}
    >
      {children}
    </motion.div>
  );
};
